export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";